(function () {
  "use strict";

  if (window.__CARD_PRODUCT_SWIPE__) return;
  window.__CARD_PRODUCT_SWIPE__ = true;

  var SWIPE_THRESHOLD = 40;
  var bound = new WeakSet();
  var recommendationSwatchBound = new WeakSet();
  var recommendationSwatchUiBound = new WeakSet();
  var recommendationCardState = new WeakMap();
  var zoomBound = new WeakSet();
  var preloadedRecommendationSwatchUrls = new Set();
  var preloadedRecommendationSwatchImageUrls = new Set();
  var allowSwipeEverywhere = true;
  var zoomEnabled = window.matchMedia &&
    window.matchMedia("(hover: hover) and (pointer: fine)").matches;
  var ZOOM_FOLLOW_LERP = 0.2;

  var hasTouch = ("ontouchstart" in window) ||
    (window.matchMedia && window.matchMedia("(pointer: coarse)").matches) ||
    (navigator && navigator.maxTouchPoints && navigator.maxTouchPoints > 0);

  function prefersReducedMotion() {
    return !!(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches);
  }

  function dataBool(value, fallback) {
    if (value === undefined) return fallback;
    if (value === "true") return true;
    if (value === "false") return false;
    return fallback;
  }

  function normalizePrefetchUrl(url) {
    var raw = (url || "").trim();
    if (!raw) return "";
    try {
      var parsed = new URL(raw, window.location.href);
      parsed.hash = "";
      return parsed.toString();
    } catch (error) {
      return "";
    }
  }

  function enqueueDocumentPrefetch(url) {
    var normalized = normalizePrefetchUrl(url);
    if (!normalized) return;
    if (preloadedRecommendationSwatchUrls.has(normalized)) return;
    preloadedRecommendationSwatchUrls.add(normalized);

    var parsedUrl;
    try {
      parsedUrl = new URL(normalized, window.location.href);
    } catch (error) {
      return;
    }

    if (parsedUrl.origin !== window.location.origin) return;

    var link = document.createElement("link");
    link.rel = "prefetch";
    link.as = "document";
    link.href = normalized;
    document.head.appendChild(link);
  }

  function enqueueImagePreload(url) {
    var normalized = normalizePrefetchUrl(url);
    if (!normalized) return;
    if (preloadedRecommendationSwatchImageUrls.has(normalized)) return;
    preloadedRecommendationSwatchImageUrls.add(normalized);

    var img = new Image();
    img.decoding = "async";
    img.src = normalized;
  }

  function isRecommendationContext(card) {
    if (!card || !card.closest) return false;
    // Product comparison cards are handled by section-specific logic and
    // must not be processed by recommendation swatch handlers.
    if (card.hasAttribute && card.hasAttribute("data-comparison-card")) return false;
    if (card.classList && card.classList.contains("card--recommendation")) return true;
    if (card.querySelector && card.querySelector(".swatches [data-target-url]")) return true;
    if (card.querySelector && card.querySelector('.swatches [data-recommendation-swatch="true"]')) return true;
    if (card.closest('[data-context="recommendations"]')) return true;
    if (card.closest('[data-context="recently_viewed"]')) return true;
    if (card.closest("product-recommendations")) return true;
    return false;
  }

  function getCardPrimaryLink(card) {
    if (!card || !card.querySelector) return null;
    return card.querySelector(".card-media[href], .card-title a[href]");
  }

  function getCardNodeFromTrackChild(trackChild) {
    if (!trackChild || !trackChild.querySelector) return null;
    if (trackChild.classList && trackChild.classList.contains("card") && trackChild.classList.contains("card--product")) {
      return trackChild;
    }
    return trackChild.querySelector(".card.card--product");
  }

  function normalizePathname(pathname) {
    var normalized = (pathname || "").trim();
    if (!normalized) return "";
    normalized = normalized.replace(/\/+$/, "");
    return normalized || "/";
  }

  function getNormalizedPathFromUrl(url) {
    var raw = (url || "").trim();
    if (!raw) return "";
    try {
      var parsed = new URL(raw, window.location.href);
      return normalizePathname(parsed.pathname);
    } catch (error) {
      return "";
    }
  }

  function getCardPathKey(card) {
    var cardLink = getCardPrimaryLink(card);
    if (!cardLink) return "";
    return getNormalizedPathFromUrl(cardLink.getAttribute("href") || "");
  }

  function collectCardSwatchPathKeys(card, targetSet) {
    if (!card || !targetSet || !card.querySelectorAll) return;
    var swatches = card.querySelectorAll(".swatches [data-target-url], .swatches a[href]");
    for (var i = 0; i < swatches.length; i++) {
      var swatchUrl = getSwatchTargetUrl(swatches[i]) || swatches[i].getAttribute("href") || "";
      var swatchPath = getNormalizedPathFromUrl(swatchUrl);
      if (!swatchPath) continue;
      targetSet.add(swatchPath);
    }
  }

  function dedupeRecommendationTrackCards(track) {
    if (!track || !track.children || !track.children.length) return false;

    var children = Array.prototype.slice.call(track.children);
    var seenPaths = new Set();
    var removedAny = false;

    for (var i = 0; i < children.length; i++) {
      var child = children[i];
      var card = getCardNodeFromTrackChild(child);
      if (!card || !isRecommendationContext(card)) continue;

      var cardPath = getCardPathKey(card);
      if (cardPath && seenPaths.has(cardPath)) {
        if (child.parentNode) {
          child.parentNode.removeChild(child);
          removedAny = true;
        }
        continue;
      }

      if (cardPath) {
        seenPaths.add(cardPath);
      }
      collectCardSwatchPathKeys(card, seenPaths);
    }

    return removedAny;
  }

  function parseRecommendationCardPrice(card) {
    if (!card || !card.querySelector) return Number.POSITIVE_INFINITY;
    var priceEl =
      card.querySelector(".price__sale .price-item--sale") ||
      card.querySelector(".price__regular .price-item--regular") ||
      card.querySelector(".price-item--last") ||
      card.querySelector(".price-item");
    if (!priceEl) return Number.POSITIVE_INFINITY;

    var raw = (priceEl.textContent || "").trim();
    if (!raw) return Number.POSITIVE_INFINITY;

    var normalized = raw.replace(/\s/g, "").replace(/[^\d,.-]/g, "");
    if (!normalized) return Number.POSITIVE_INFINITY;

    var value = normalized;
    var hasComma = value.indexOf(",") !== -1;
    var hasDot = value.indexOf(".") !== -1;

    if (hasComma && hasDot) {
      if (value.lastIndexOf(",") > value.lastIndexOf(".")) {
        value = value.replace(/\./g, "").replace(",", ".");
      } else {
        value = value.replace(/,/g, "");
      }
    } else if (hasComma) {
      var commaParts = value.split(",");
      if (commaParts[1] && commaParts[1].length <= 2) {
        value = commaParts[0].replace(/\./g, "") + "." + commaParts[1];
      } else {
        value = value.replace(/,/g, "");
      }
    } else {
      value = value.replace(/\./g, "");
    }

    var parsed = Number.parseFloat(value);
    return Number.isFinite(parsed) ? parsed : Number.POSITIVE_INFINITY;
  }

  function sortRecommendationTrackCardsByPrice(track) {
    if (!track || !track.children || track.children.length < 2) return false;

    var children = Array.prototype.slice.call(track.children);
    var rows = [];
    for (var i = 0; i < children.length; i++) {
      var child = children[i];
      var card = getCardNodeFromTrackChild(child);
      if (!card || !isRecommendationContext(card)) return false;
      rows.push({
        child: child,
        price: parseRecommendationCardPrice(card),
        index: i
      });
    }
    if (rows.length < 2) return false;

    rows.sort(function(a, b) {
      var aFinite = Number.isFinite(a.price);
      var bFinite = Number.isFinite(b.price);
      if (aFinite && !bFinite) return -1;
      if (!aFinite && bFinite) return 1;
      if (aFinite && bFinite) {
        if (a.price !== b.price) return a.price - b.price;
      }
      return a.index - b.index;
    });

    var changed = false;
    for (var j = 0; j < rows.length; j++) {
      if (rows[j].child !== children[j]) {
        changed = true;
        break;
      }
    }
    if (!changed) return false;

    var fragment = document.createDocumentFragment();
    for (var k = 0; k < rows.length; k++) {
      fragment.appendChild(rows[k].child);
    }
    track.appendChild(fragment);

    var slider = track.closest && track.closest("gridy-slider");
    if (slider && typeof slider.refreshSlides === "function") {
      slider.refreshSlides();
    }

    return true;
  }

  function dedupeRecommendationCardsInScope(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var selectors = [
      '[data-context="recommendations"] .gridy-track',
      '[data-context="recently_viewed"] .gridy-track',
      "product-recommendations .gridy-track"
    ];
    var seenTracks = new Set();

    for (var s = 0; s < selectors.length; s++) {
      var tracks = root.querySelectorAll(selectors[s]);
      for (var t = 0; t < tracks.length; t++) {
        var track = tracks[t];
        if (seenTracks.has(track)) continue;
        seenTracks.add(track);
        dedupeRecommendationTrackCards(track);
      }
    }
  }

  function sortRecommendationCardsInScope(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var selectors = [
      '[data-context="recommendations"] .gridy-track',
      "product-recommendations .gridy-track"
    ];
    var seenTracks = new Set();

    for (var s = 0; s < selectors.length; s++) {
      var tracks = root.querySelectorAll(selectors[s]);
      for (var t = 0; t < tracks.length; t++) {
        var track = tracks[t];
        if (seenTracks.has(track)) continue;
        seenTracks.add(track);
        sortRecommendationTrackCardsByPrice(track);
      }
    }
  }

  function extractProductHandleFromUrl(url) {
    var path = getNormalizedPathFromUrl(url);
    if (!path) return "";
    var match = path.match(/\/products\/([^\/?#]+)/i);
    if (!match || !match[1]) return "";
    try {
      return decodeURIComponent(match[1]).toLowerCase();
    } catch (error) {
      return (match[1] || "").toLowerCase();
    }
  }

  function isSingleSwatchForSameProduct(card) {
    if (!card || !card.querySelectorAll) return false;
    var swatches = card.querySelectorAll(".swatches a[href]");
    if (!swatches || swatches.length !== 1) return false;

    var cardLink = getCardPrimaryLink(card);
    if (!cardLink) return false;

    var cardHref = cardLink.getAttribute("href");
    var swatchHref = swatches[0].getAttribute("href");
    var cardHandle = extractProductHandleFromUrl(cardHref);
    var swatchHandle = extractProductHandleFromUrl(swatchHref);

    if (cardHandle && swatchHandle) {
      return cardHandle === swatchHandle;
    }

    var cardPath = getNormalizedPathFromUrl(cardHref);
    var swatchPath = getNormalizedPathFromUrl(swatchHref);
    if (!cardPath || !swatchPath) return false;
    return cardPath === swatchPath;
  }

  function updateSingleSwatchHoverLock(card) {
    if (!card || !card.classList) return false;

    var isComparisonCard = card.hasAttribute && card.hasAttribute("data-comparison-card");
    var shouldLock = !isComparisonCard && isSingleSwatchForSameProduct(card);
    card.classList.toggle("single-self-swatch-lock", shouldLock);

    if (shouldLock) {
      card.classList.remove("is-hovered");
      card.classList.remove("is-secondary");
      hideIndicators(card);
    }

    return shouldLock;
  }

  function preloadRecommendationCardSwatches(card) {
    if (!card || card.dataset.swatchPrefetched === "true") return;
    if (!isRecommendationContext(card)) return;

    var swatchLinks = card.querySelectorAll(".swatches a[href]");
    if (!swatchLinks.length) return;

    card.dataset.swatchPrefetched = "true";
    for (var i = 0; i < swatchLinks.length; i++) {
      preloadRecommendationSwatchAssets(swatchLinks[i]);
    }
  }

  function bindRecommendationSwatchPrefetch(card) {
    if (!hasTouch || !card || recommendationSwatchBound.has(card)) return;
    if (!isRecommendationContext(card)) return;
    recommendationSwatchBound.add(card);

    var swatchRow = card.querySelector(".swatches");
    if (!swatchRow) return;

    var triggerPrefetch = function () {
      preloadRecommendationCardSwatches(card);
    };

    swatchRow.addEventListener("pointerdown", triggerPrefetch, { passive: true });
    swatchRow.addEventListener("touchstart", triggerPrefetch, { passive: true });
    swatchRow.addEventListener("click", triggerPrefetch, { passive: true });
    swatchRow.addEventListener("contextmenu", triggerPrefetch);
  }

  function createFragmentFromHtml(html) {
    var wrapper = document.createElement("div");
    wrapper.innerHTML = html || "";
    return wrapper;
  }

  function sanitizeSveaListingRoots(scope) {
    if (!scope) return;

    var roots = [];
    if (scope.matches && scope.matches('.svea-listing[data-svea-listing="true"]')) {
      roots.push(scope);
    }
    if (scope.querySelectorAll) {
      var nestedRoots = scope.querySelectorAll('.svea-listing[data-svea-listing="true"]');
      for (var i = 0; i < nestedRoots.length; i++) {
        roots.push(nestedRoots[i]);
      }
    }

    for (var j = 0; j < roots.length; j++) {
      var root = roots[j];
      root.removeAttribute("data-svea-listing-ready");
      root.removeAttribute("data-svea-listing-processing");
      root.removeAttribute("data-svea-listing-observed");
      root.removeAttribute("data-svea-listing-attempts");

      var textNode = root.querySelector("[data-svea-listing-text]");
      if (textNode) {
        textNode.textContent = "\u00A0";
      }

      var runtime = root.querySelector("[data-svea-listing-calc]");
      if (runtime) {
        runtime.innerHTML = "";
      }

      var row = root.closest(".svea-listing-row");
      if (row) {
        row.hidden = false;
        row.classList.remove("is-ready");
        row.classList.remove("is-hidden");
      }
    }
  }

  function serializeCleanComparisonMeta(node) {
    if (!node || !node.cloneNode) return "";
    var clone = node.cloneNode(true);
    sanitizeSveaListingRoots(clone);
    return clone.outerHTML || "";
  }

  function refreshSveaListings(scope) {
    if (!scope || !window.SveaListing || typeof window.SveaListing.init !== "function") return;

    sanitizeSveaListingRoots(scope);
    window.SveaListing.init(scope);

    requestAnimationFrame(function () {
      if (!scope || !scope.isConnected) return;
      window.SveaListing.init(scope);
    });

    setTimeout(function () {
      if (!scope || !scope.isConnected) return;
      window.SveaListing.init(scope);
    }, 180);
  }

  function initSveaListings(scope) {
    if (!scope || !window.SveaListing || typeof window.SveaListing.init !== "function") return;

    window.SveaListing.init(scope);

    requestAnimationFrame(function () {
      if (!scope || (scope !== document && !scope.isConnected)) return;
      window.SveaListing.init(scope);
    });

    setTimeout(function () {
      if (!scope || (scope !== document && !scope.isConnected)) return;
      window.SveaListing.init(scope);
    }, 180);
  }

  function getSwatchTargetUrl(swatch) {
    if (!swatch) return "";
    return swatch.dataset.targetUrl || swatch.getAttribute("href") || "";
  }

  function preloadRecommendationSwatchAssets(swatch) {
    if (!swatch) return;
    enqueueDocumentPrefetch(getSwatchTargetUrl(swatch));
    enqueueImagePreload(swatch.dataset.targetImage || "");
    enqueueImagePreload(swatch.dataset.targetSecondaryImage || "");
  }

  function getCardMediaTargets(card) {
    var media = card ? card.querySelector(".card-media") : null;
    if (!media) return { media: null, primary: null, secondary: null };

    var hoverWrap = media.querySelector(".card-hover-images");
    var primary = null;
    if (hoverWrap && hoverWrap.children && hoverWrap.children.length) {
      primary = hoverWrap.children[0];
    } else {
      primary = media.querySelector(".media") || media;
    }
    var secondary = hoverWrap && hoverWrap.children && hoverWrap.children.length > 1 ? hoverWrap.children[1] : null;

    return { media: media, primary: primary, secondary: secondary };
  }

  function updateImageSources(scope, url) {
    var normalized = normalizeImageUrl(url);
    if (!scope || !normalized) return;

    var sourceNodes = scope.querySelectorAll("picture source");
    for (var s = 0; s < sourceNodes.length; s++) {
      sourceNodes[s].removeAttribute("srcset");
      sourceNodes[s].removeAttribute("sizes");
    }

    var images = [];
    if (scope.tagName && scope.tagName.toLowerCase() === "img") {
      images.push(scope);
    }
    var scopedImages = scope.querySelectorAll("img");
    for (var i = 0; i < scopedImages.length; i++) {
      images.push(scopedImages[i]);
    }

    for (var j = 0; j < images.length; j++) {
      images[j].setAttribute("src", normalized);
      images[j].removeAttribute("srcset");
      images[j].removeAttribute("data-srcset");
    }
  }

  function animateTextContentSwap(node, nextText) {
    if (!node) return;
    var value = (nextText || "").trim();
    if (!value) return;
    if ((node.textContent || "").trim() === value) return;

    var outMs = 80;
    var inMs = 170;
    node.style.willChange = "opacity, transform";
    node.style.transition = "opacity " + outMs + "ms ease, transform " + outMs + "ms ease";
    node.style.opacity = "0";
    node.style.transform = "translateY(-2px)";

    setTimeout(function () {
      node.textContent = value;
      node.style.transition = "opacity " + inMs + "ms ease, transform " + inMs + "ms ease";
      node.style.opacity = "1";
      node.style.transform = "translateY(0)";
      setTimeout(function () {
        node.style.removeProperty("will-change");
        node.style.removeProperty("transition");
        node.style.removeProperty("opacity");
        node.style.removeProperty("transform");
      }, inMs + 30);
    }, outMs);
  }

  function splitTitlePartsByComma(title) {
    var raw = (title || "").trim();
    if (!raw) {
      return {
        primary: "",
        secondary: "",
        full: ""
      };
    }

    var parts = raw.split(",");
    var primary = (parts.shift() || "").trim();
    var secondary = "";

    for (var i = 0; i < parts.length; i++) {
      var clean = (parts[i] || "").trim();
      if (!clean) continue;
      secondary = secondary ? (secondary + ", " + clean) : clean;
    }

    if (!primary && secondary) {
      primary = secondary;
      secondary = "";
    }

    return {
      primary: primary,
      secondary: secondary,
      full: secondary ? (primary + ", " + secondary) : primary
    };
  }

  function getTitlePartsFromLink(titleLink) {
    if (!titleLink) {
      return splitTitlePartsByComma("");
    }

    var primaryNode = titleLink.querySelector(".card-title__primary");
    var secondaryNode = titleLink.querySelector(".card-title__secondary");
    if (primaryNode || secondaryNode) {
      var primaryText = primaryNode ? (primaryNode.textContent || "").trim() : "";
      var secondaryText = secondaryNode ? (secondaryNode.textContent || "").trim() : "";
      return {
        primary: primaryText,
        secondary: secondaryText,
        full: secondaryText ? (primaryText + ", " + secondaryText) : primaryText
      };
    }

    return splitTitlePartsByComma(titleLink.textContent || "");
  }

  function getTitlePartsFromSnapshot(snapshot) {
    if (!snapshot) {
      return splitTitlePartsByComma("");
    }

    var primary = (snapshot.titlePrimary || "").trim();
    var secondary = (snapshot.titleSecondary || "").trim();
    if (primary || secondary) {
      if (!primary && secondary) {
        primary = secondary;
        secondary = "";
      }
      return {
        primary: primary,
        secondary: secondary,
        full: secondary ? (primary + ", " + secondary) : primary
      };
    }

    return splitTitlePartsByComma(snapshot.title || "");
  }

  function applyTitlePartsToLink(titleLink, snapshot, options) {
    if (!titleLink) return;

    var next = getTitlePartsFromSnapshot(snapshot);
    if (!next.primary && !next.secondary) return;

    var current = getTitlePartsFromLink(titleLink);
    if (current.primary === next.primary && current.secondary === next.secondary) return;

    var updateNodes = function () {
      var primaryNode = titleLink.querySelector(".card-title__primary");
      var secondaryNode = titleLink.querySelector(".card-title__secondary");

      if (!primaryNode) {
        titleLink.textContent = "";
        primaryNode = document.createElement("span");
        primaryNode.className = "card-title__primary";
        titleLink.appendChild(primaryNode);
      }
      primaryNode.textContent = next.primary;

      if (next.secondary) {
        if (!secondaryNode) {
          secondaryNode = document.createElement("span");
          secondaryNode.className = "card-title__secondary";
          titleLink.appendChild(secondaryNode);
        }
        secondaryNode.textContent = next.secondary;
      } else if (secondaryNode) {
        secondaryNode.remove();
      }
    };

    if (options && options.immediate) {
      updateNodes();
      return;
    }

    var outMs = 80;
    var inMs = 170;
    titleLink.style.willChange = "opacity, transform";
    titleLink.style.transition = "opacity " + outMs + "ms ease, transform " + outMs + "ms ease";
    titleLink.style.opacity = "0";
    titleLink.style.transform = "translateY(-2px)";

    setTimeout(function () {
      updateNodes();

      titleLink.style.transition = "opacity " + inMs + "ms ease, transform " + inMs + "ms ease";
      titleLink.style.opacity = "1";
      titleLink.style.transform = "translateY(0)";
      setTimeout(function () {
        titleLink.style.removeProperty("will-change");
        titleLink.style.removeProperty("transition");
        titleLink.style.removeProperty("opacity");
        titleLink.style.removeProperty("transform");
      }, inMs + 30);
    }, outMs);
  }

  function animateNodeEnter(node, duration, translateIn) {
    if (!node) return;
    var inMs = duration || 180;
    var y = translateIn || 5;
    node.style.opacity = "0";
    node.style.transform = "translateY(" + y + "px)";
    node.style.willChange = "opacity, transform";
    node.style.transition = "none";

    requestAnimationFrame(function () {
      node.style.transition = "opacity " + inMs + "ms ease, transform " + inMs + "ms ease";
      node.style.opacity = "1";
      node.style.transform = "translateY(0)";
      setTimeout(function () {
        node.style.removeProperty("will-change");
        node.style.removeProperty("transition");
        node.style.removeProperty("opacity");
        node.style.removeProperty("transform");
      }, inMs + 30);
    });
  }

  function animateNodeReplace(oldNode, nextNode, outDuration, inDuration) {
    if (!oldNode || !nextNode || !oldNode.parentNode) return false;
    var outMs = outDuration || 90;
    var inMs = inDuration || 180;

    oldNode.style.willChange = "opacity, transform";
    oldNode.style.transition = "opacity " + outMs + "ms ease, transform " + outMs + "ms ease";
    oldNode.style.opacity = "0";
    oldNode.style.transform = "translateY(-3px)";

    setTimeout(function () {
      if (!oldNode.parentNode) return;
      oldNode.replaceWith(nextNode);
      animateNodeEnter(nextNode, inMs, 4);
    }, outMs);

    return true;
  }

  function animateImageSwap(scope, url) {
    var normalized = normalizeImageUrl(url || "");
    if (!scope || !normalized) return;

    var scopeTag = scope.tagName ? scope.tagName.toLowerCase() : "";
    var scopeIsImageNode = scopeTag === "img";
    var currentImg = scopeIsImageNode ? scope : scope.querySelector("img");
    var currentUrl = currentImg ? normalizeImageUrl(currentImg.currentSrc || currentImg.getAttribute("src") || "") : "";
    var currentKey = getImageIdentityKey(currentUrl);
    var nextKey = getImageIdentityKey(normalized);
    if (currentKey && nextKey && currentKey === nextKey) {
      updateImageSources(scope, normalized);
      return;
    }
    if (prefersReducedMotion()) {
      updateImageSources(scope, normalized);
      return;
    }
    if (!currentImg) {
      var outMs = 80;
      var inMs = 190;
      scope.style.willChange = "opacity";
      scope.style.transition = "opacity " + outMs + "ms ease";
      scope.style.opacity = "0";
      setTimeout(function () {
        updateImageSources(scope, normalized);
        scope.style.transition = "opacity " + inMs + "ms ease";
        scope.style.opacity = "1";
        setTimeout(function () {
          scope.style.removeProperty("will-change");
          scope.style.removeProperty("transition");
          scope.style.removeProperty("opacity");
        }, inMs + 40);
      }, outMs + 20);
      return;
    }

    var fadeHost = scope;
    if (scopeIsImageNode && scope.parentElement) {
      var candidateHost = scope.parentElement;
      if (candidateHost.querySelectorAll("img").length === 1) {
        fadeHost = candidateHost;
      }
    }
    if (!fadeHost || !fadeHost.appendChild) {
      updateImageSources(scope, normalized);
      return;
    }

    fadeHost.classList.add("card-swatch-fade-scope");
    scope.__cardImageSwapToken = (scope.__cardImageSwapToken || 0) + 1;
    var imageSwapToken = scope.__cardImageSwapToken;

    if (scope.__cardFinalizeSwapTimer) {
      clearTimeout(scope.__cardFinalizeSwapTimer);
      scope.__cardFinalizeSwapTimer = null;
    }
    if (scope.__cardActiveFadeLayer && scope.__cardActiveFadeLayer.parentNode) {
      scope.__cardActiveFadeLayer.parentNode.removeChild(scope.__cardActiveFadeLayer);
    }
    scope.__cardActiveFadeLayer = null;

    var fadeLayer = document.createElement("img");
    fadeLayer.className = "card-swatch-fade-layer";
    fadeLayer.decoding = "async";
    fadeLayer.loading = "eager";
    fadeLayer.src = normalized;
    fadeLayer.style.display = "block";
    fadeLayer.style.opacity = "0";
    fadeLayer.style.transition = "opacity 260ms cubic-bezier(0.22, 0.61, 0.36, 1)";

    var altText = currentImg.getAttribute("alt");
    if (altText != null) {
      fadeLayer.setAttribute("alt", altText);
    }

    if (window.getComputedStyle) {
      var imgStyle = window.getComputedStyle(currentImg);
      if (imgStyle.objectFit) fadeLayer.style.objectFit = imgStyle.objectFit;
      if (imgStyle.objectPosition) fadeLayer.style.objectPosition = imgStyle.objectPosition;
    }

    fadeHost.appendChild(fadeLayer);
    scope.__cardActiveFadeLayer = fadeLayer;

    var hasAppliedUpdate = false;
    var cleanupLayer = function () {
      if (scope.__cardActiveFadeLayer === fadeLayer) {
        scope.__cardActiveFadeLayer = null;
      }
      if (fadeLayer.parentNode) {
        fadeLayer.parentNode.removeChild(fadeLayer);
      }
    };

    var finalizeSwap = function () {
      if (hasAppliedUpdate) return;
      if (scope.__cardImageSwapToken !== imageSwapToken) return;
      hasAppliedUpdate = true;
      updateImageSources(scope, normalized);
      setTimeout(cleanupLayer, 90);
    };

    var revealLayer = function () {
      if (scope.__cardImageSwapToken !== imageSwapToken) return;
      void fadeLayer.offsetWidth;
      requestAnimationFrame(function () {
        if (scope.__cardImageSwapToken !== imageSwapToken) return;
        fadeLayer.style.opacity = "1";
      });
    };

    fadeLayer.addEventListener("transitionend", function (event) {
      if (event.propertyName !== "opacity") return;
      if (scope.__cardImageSwapToken !== imageSwapToken) return;
      finalizeSwap();
    });

    fadeLayer.addEventListener("error", function () {
      updateImageSources(scope, normalized);
      cleanupLayer();
    }, { once: true });

    if (fadeLayer.complete) {
      revealLayer();
    } else {
      fadeLayer.addEventListener("load", function () {
        revealLayer();
      }, { once: true });
    }

    scope.__cardFinalizeSwapTimer = setTimeout(function () {
      scope.__cardFinalizeSwapTimer = null;
      if (scope.__cardImageSwapToken !== imageSwapToken) return;
      if (!hasAppliedUpdate) {
        finalizeSwap();
      }
    }, 360);
  }

  function readRecommendationCardSnapshot(card) {
    var mediaLink = card.querySelector(".card-media[href]");
    var titleLink = card.querySelector(".card-title a[href]");
    var priceNode = card.querySelector(".title-price-container .price");
    var metaNode = card.querySelector(".product-comparison__meta");
    var mediaTargets = getCardMediaTargets(card);
    var primaryImg = mediaTargets.primary ? mediaTargets.primary.querySelector("img") : null;
    var secondaryImg = mediaTargets.secondary ? mediaTargets.secondary.querySelector("img") : null;
    var titleParts = getTitlePartsFromLink(titleLink);

    return {
      url: mediaLink ? (mediaLink.getAttribute("href") || "") : (titleLink ? (titleLink.getAttribute("href") || "") : ""),
      title: titleParts.full,
      titlePrimary: titleParts.primary,
      titleSecondary: titleParts.secondary,
      variantId: (card && card.dataset ? (card.dataset.cardVariantId || "") : "").trim(),
      sku: (card && card.dataset ? (card.dataset.cardSku || "") : "").trim(),
      priceHtml: priceNode ? priceNode.outerHTML : "",
      metaHtml: metaNode ? serializeCleanComparisonMeta(metaNode) : "",
      imageUrl: primaryImg ? (primaryImg.currentSrc || primaryImg.getAttribute("src") || "") : "",
      secondaryImageUrl: secondaryImg ? (secondaryImg.currentSrc || secondaryImg.getAttribute("src") || "") : ""
    };
  }

  function readRecommendationSwatchSnapshot(swatch) {
    var titlePrimary = swatch ? (swatch.dataset.targetTitlePrimary || "") : "";
    var titleSecondary = swatch ? (swatch.dataset.targetTitleSecondary || "") : "";
    var titleCombined = swatch ? (swatch.dataset.targetTitle || "") : "";
    if (!titlePrimary && !titleSecondary) {
      var fallbackParts = splitTitlePartsByComma(titleCombined);
      titlePrimary = fallbackParts.primary;
      titleSecondary = fallbackParts.secondary;
      titleCombined = fallbackParts.full;
    } else if (!titleCombined) {
      titleCombined = titleSecondary ? (titlePrimary + ", " + titleSecondary) : titlePrimary;
    }

    return {
      url: swatch ? (swatch.dataset.targetUrl || "") : "",
      title: titleCombined,
      titlePrimary: titlePrimary,
      titleSecondary: titleSecondary,
      variantId: swatch ? ((swatch.dataset.targetVariantId || "").trim()) : "",
      sku: swatch ? ((swatch.dataset.targetSku || "").trim()) : "",
      priceHtml: swatch ? (swatch.dataset.targetPriceHtml || "") : "",
      metaHtml: swatch ? (swatch.dataset.targetComparisonMetaHtml || "") : "",
      imageUrl: swatch ? (swatch.dataset.targetImage || "") : "",
      secondaryImageUrl: swatch ? (swatch.dataset.targetSecondaryImage || "") : ""
    };
  }

  function getRecommendationSnapshotKey(snapshot) {
    if (!snapshot) return "";
    var titleParts = getTitlePartsFromSnapshot(snapshot);
    return [
      normalizePrefetchUrl(snapshot.url || ""),
      getImageIdentityKey(snapshot.imageUrl || ""),
      getImageIdentityKey(snapshot.secondaryImageUrl || ""),
      titleParts.primary,
      titleParts.secondary,
      (snapshot.variantId || "").trim(),
      (snapshot.sku || "").trim().toLowerCase(),
      (snapshot.priceHtml || "").trim().length,
      (snapshot.metaHtml || "").trim().length
    ].join("|");
  }

  function applyRecommendationSnapshot(card, snapshot) {
    if (!card || !snapshot) return;

    var mediaLink = card.querySelector(".card-media[href]");
    var titleLink = card.querySelector(".card-title a[href]");
    var titlePriceContainer = card.querySelector(".title-price-container");
    var existingPrice = titlePriceContainer ? titlePriceContainer.querySelector(".price") : null;
    var existingMeta = card.querySelector(".product-comparison__meta");

    if (snapshot.url) {
      if (mediaLink) mediaLink.setAttribute("href", snapshot.url);
      if (titleLink) titleLink.setAttribute("href", snapshot.url);
    }
    if (card.dataset) {
      card.dataset.cardVariantId = (snapshot.variantId || "").trim();
      card.dataset.cardSku = (snapshot.sku || "").trim();
    }
    if (titleLink) {
      applyTitlePartsToLink(titleLink, snapshot, { immediate: true });
    }

    if (titlePriceContainer) {
      var snapshotPriceHtml = (snapshot.priceHtml || "").trim();
      if (!snapshotPriceHtml && existingPrice) {
        snapshotPriceHtml = existingPrice.outerHTML || "";
      }
      if (snapshotPriceHtml) {
        var priceWrapper = createFragmentFromHtml(snapshotPriceHtml);
        var nextPrice = priceWrapper.querySelector(".price") || priceWrapper.firstElementChild;
        if (nextPrice) {
          if (existingPrice) {
            existingPrice.replaceWith(nextPrice);
          } else {
            titlePriceContainer.appendChild(nextPrice);
          }
        }
      } else if (existingPrice) {
        existingPrice.remove();
      }
    }

    if (snapshot.metaHtml) {
      var metaWrapper = createFragmentFromHtml(snapshot.metaHtml);
      var nextMeta = metaWrapper.querySelector(".product-comparison__meta") || metaWrapper.firstElementChild;
      if (nextMeta) {
        if (existingMeta) {
          existingMeta.replaceWith(nextMeta);
        } else {
          var insertionAnchor = card.querySelector(".swatches") || card.querySelector(".title-price-container");
          if (insertionAnchor && insertionAnchor.parentNode) {
            insertionAnchor.insertAdjacentElement("afterend", nextMeta);
          } else {
            var body = card.querySelector(".card-body");
            if (body) {
              body.appendChild(nextMeta);
            }
          }
        }
      }
    } else if (existingMeta) {
      existingMeta.remove();
    }

    refreshSveaListings(card);

    var mediaTargets = getCardMediaTargets(card);
    if (snapshot.imageUrl && mediaTargets.primary) {
      animateImageSwap(mediaTargets.primary, snapshot.imageUrl);
    }
    if (mediaTargets.secondary) {
      var nextSecondary = snapshot.secondaryImageUrl || snapshot.imageUrl || "";
      if (nextSecondary) {
        animateImageSwap(mediaTargets.secondary, nextSecondary);
      }

      var hasDistinctSecondary = false;
      if (snapshot.imageUrl && nextSecondary) {
        hasDistinctSecondary = getImageIdentityKey(snapshot.imageUrl) !== getImageIdentityKey(nextSecondary);
      }

      if (hasDistinctSecondary) {
        card.classList.remove("comparison-lock-hover-image");
        var indicators = card.querySelector(".card-image-indicators");
        if (indicators) indicators.style.removeProperty("display");
      } else {
        card.classList.add("comparison-lock-hover-image");
        card.classList.remove("is-hovered");
        card.classList.remove("is-secondary");
        hideIndicators(card);
      }
    }

    updateSingleSwatchHoverLock(card);
  }

  function syncRecommendationSwatchSelection(card) {
    if (!card || !isRecommendationContext(card)) return;
    var swatchRow = card.querySelector(".swatches");
    if (swatchRow) {
      swatchRow.classList.remove("has-hovered-swatch");
    }
    var swatchLinks = card.querySelectorAll('.swatches [data-recommendation-swatch="true"], .swatches a[href]');
    if (!swatchLinks || !swatchLinks.length) return;
    var state = recommendationCardState.get(card);

    if (state && state.committedSwatch && state.committedSwatch.isConnected) {
      for (var s = 0; s < swatchLinks.length; s++) {
        swatchLinks[s].classList.remove("is-hovered");
        swatchLinks[s].classList.toggle("is-selected", swatchLinks[s] === state.committedSwatch);
      }
      return;
    }

    var cardLink = getCardPrimaryLink(card);
    if (!cardLink) return;

    var cardHref = cardLink.getAttribute("href");
    var cardUrlKey = normalizePrefetchUrl(cardHref);
    var cardPathKey = getNormalizedPathFromUrl(cardHref);
    var cardVariantId = (card.dataset.cardVariantId || "").trim();
    var cardSku = (card.dataset.cardSku || "").trim().toLowerCase();
    var hasStrongIdentity = !!(cardVariantId || cardSku);
    var selected = null;

    for (var i = 0; i < swatchLinks.length; i++) {
      var swatch = swatchLinks[i];
      swatch.classList.remove("is-hovered");
      swatch.classList.remove("is-selected");

      var swatchVariantId = (swatch.dataset.targetVariantId || "").trim();
      var swatchSku = (swatch.dataset.targetSku || "").trim().toLowerCase();
      var swatchHref = getSwatchTargetUrl(swatch);
      var swatchUrlKey = normalizePrefetchUrl(swatchHref);
      var swatchPathKey = getNormalizedPathFromUrl(swatchHref);

      if (!selected && cardVariantId && swatchVariantId && swatchVariantId === cardVariantId) {
        selected = swatch;
        continue;
      }
      if (!selected && cardSku && swatchSku && swatchSku === cardSku) {
        selected = swatch;
        continue;
      }
      if (!selected && cardUrlKey && swatchUrlKey && swatchUrlKey === cardUrlKey) {
        selected = swatch;
        continue;
      }
      if (!selected && !hasStrongIdentity && cardPathKey && swatchPathKey && swatchPathKey === cardPathKey) {
        selected = swatch;
      }
    }

    if (!selected && swatchLinks.length === 1) {
      selected = swatchLinks[0];
    }
    if (selected) {
      selected.classList.add("is-selected");
    }
  }

  function bindRecommendationSwatchInteractions(card) {
    if (!card || recommendationSwatchUiBound.has(card)) return;
    if (!isRecommendationContext(card)) return;
    recommendationSwatchUiBound.add(card);

    var swatchRow = card.querySelector(".swatches");
    if (!swatchRow) return;

    var swatches = Array.prototype.slice.call(swatchRow.querySelectorAll('[data-recommendation-swatch="true"]'));
    if (!swatches.length) {
      swatches = Array.prototype.slice.call(swatchRow.querySelectorAll("a[href]"));
    }
    if (!swatches.length) return;

    var hasPreloadedSwatchAssets = false;
    var preloadAllSwatchAssets = function () {
      if (hasPreloadedSwatchAssets) return;
      hasPreloadedSwatchAssets = true;
      for (var preloadIndex = 0; preloadIndex < swatches.length; preloadIndex++) {
        preloadRecommendationSwatchAssets(swatches[preloadIndex]);
      }
    };

    var baseSnapshot = readRecommendationCardSnapshot(card);
    var baseSnapshotKey = getRecommendationSnapshotKey(baseSnapshot);
    var baseUrlKey = normalizePrefetchUrl(baseSnapshot.url);
    var basePathKey = getNormalizedPathFromUrl(baseSnapshot.url);
    var baseVariantId = (card.dataset.cardVariantId || "").trim();
    var baseSku = (card.dataset.cardSku || "").trim().toLowerCase();
    var hasStrongIdentity = !!(baseVariantId || baseSku);
    var committedSwatch = null;

    for (var i = 0; i < swatches.length; i++) {
      var candidateVariantId = (swatches[i].dataset.targetVariantId || "").trim();
      var candidateSku = (swatches[i].dataset.targetSku || "").trim().toLowerCase();
      var candidateUrl = getSwatchTargetUrl(swatches[i]);
      var candidateUrlKey = normalizePrefetchUrl(candidateUrl);
      var candidatePathKey = getNormalizedPathFromUrl(candidateUrl);

      if (baseVariantId && candidateVariantId && baseVariantId === candidateVariantId) {
        committedSwatch = swatches[i];
        break;
      }
      if (!committedSwatch && baseSku && candidateSku && baseSku === candidateSku) {
        committedSwatch = swatches[i];
        continue;
      }
      if (baseUrlKey && candidateUrlKey && baseUrlKey === candidateUrlKey) {
        committedSwatch = swatches[i];
        break;
      }
      if (!committedSwatch && !hasStrongIdentity && basePathKey && candidatePathKey && basePathKey === candidatePathKey) {
        committedSwatch = swatches[i];
      }
    }
    if (!committedSwatch && swatches.length === 1) {
      committedSwatch = swatches[0];
    }

    var committedSnapshot = baseSnapshot;
    if (committedSwatch) {
      committedSnapshot = readRecommendationSwatchSnapshot(committedSwatch);
    }
    recommendationCardState.set(card, {
      base: baseSnapshot,
      committed: committedSnapshot,
      committedSwatch: committedSwatch,
      activeSnapshotKey: getRecommendationSnapshotKey(committedSnapshot) || baseSnapshotKey
    });

    var clearHovered = function () {
      for (var swatchIndex = 0; swatchIndex < swatches.length; swatchIndex++) {
        swatches[swatchIndex].classList.remove("is-hovered");
      }
    };

    var applySwatchClasses = function (hoveredSwatch) {
      var state = recommendationCardState.get(card);
      swatchRow.classList.toggle("has-hovered-swatch", !!hoveredSwatch);
      clearHovered();
      for (var swatchIndex = 0; swatchIndex < swatches.length; swatchIndex++) {
        var swatch = swatches[swatchIndex];
        swatch.classList.toggle("is-selected", !!(state && state.committedSwatch === swatch));
        if (hoveredSwatch && hoveredSwatch === swatch) {
          swatch.classList.add("is-hovered");
        }
      }
    };

    var previewSwatch = function (swatch) {
      if (!swatch) return;
      var state = recommendationCardState.get(card);
      if (!state) return;
      var snapshot = readRecommendationSwatchSnapshot(swatch);
      var snapshotKey = getRecommendationSnapshotKey(snapshot);
      if (snapshotKey && state.activeSnapshotKey !== snapshotKey) {
        applyRecommendationSnapshot(card, snapshot);
        state.activeSnapshotKey = snapshotKey;
        recommendationCardState.set(card, state);
      }
      applySwatchClasses(swatch);
    };

    var commitSwatch = function (swatch) {
      if (!swatch) return;
      var state = recommendationCardState.get(card);
      if (!state) return;

      state.committedSwatch = swatch;
      state.committed = readRecommendationSwatchSnapshot(swatch);

      state.activeSnapshotKey = getRecommendationSnapshotKey(state.committed);
      recommendationCardState.set(card, state);
      applyRecommendationSnapshot(card, state.committed);
      applySwatchClasses(null);
    };

    var restoreCommitted = function () {
      var state = recommendationCardState.get(card);
      if (!state) return;
      var committedSnapshot = state.committed || state.base;
      var committedKey = getRecommendationSnapshotKey(committedSnapshot);
      if (committedKey && state.activeSnapshotKey !== committedKey) {
        applyRecommendationSnapshot(card, committedSnapshot);
        state.activeSnapshotKey = committedKey;
        recommendationCardState.set(card, state);
      }
      applySwatchClasses(null);
    };

    for (var k = 0; k < swatches.length; k++) {
      (function (swatch) {
        if (zoomEnabled) {
          swatch.addEventListener("mouseenter", function () {
            preloadRecommendationSwatchAssets(swatch);
            previewSwatch(swatch);
          });
          swatch.addEventListener("pointerenter", function (event) {
            if (event.pointerType && event.pointerType !== "mouse" && event.pointerType !== "pen") return;
            preloadRecommendationSwatchAssets(swatch);
            previewSwatch(swatch);
          });
        }
        swatch.addEventListener("focus", function () {
          preloadRecommendationSwatchAssets(swatch);
          previewSwatch(swatch);
        });
        swatch.addEventListener("touchstart", function () {
          preloadRecommendationSwatchAssets(swatch);
        }, { passive: true });
        swatch.addEventListener("click", function (event) {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button === 1) {
            return;
          }
          event.preventDefault();
          commitSwatch(swatch);
        });
      })(swatches[k]);
    }

    swatchRow.addEventListener("mouseenter", preloadAllSwatchAssets, { passive: true });
    swatchRow.addEventListener("pointerdown", preloadAllSwatchAssets, { passive: true });
    swatchRow.addEventListener("touchstart", preloadAllSwatchAssets, { passive: true });
    swatchRow.addEventListener("focusin", preloadAllSwatchAssets);
    swatchRow.addEventListener("mouseleave", restoreCommitted);
    swatchRow.addEventListener("pointerleave", restoreCommitted);
    swatchRow.addEventListener("focusout", function () {
      requestAnimationFrame(function () {
        if (!swatchRow.contains(document.activeElement)) {
          restoreCommitted();
        }
      });
    });

    if (!hasTouch) {
      if (typeof window.requestIdleCallback === "function") {
        window.requestIdleCallback(preloadAllSwatchAssets, { timeout: 700 });
      } else {
        setTimeout(preloadAllSwatchAssets, 120);
      }
    }

    applySwatchClasses(null);
  }

  function isHomepage() {
    if (typeof location === "undefined") return false;
    var path = location.pathname || "";
    return path === "/" || path === "/fi" || path === "/fi/";
  }

  function isSliderEnabled(slider) {
    if (!slider) return false;
    var width = window.innerWidth || document.documentElement.clientWidth || 0;
    var mobileEnabled = dataBool(slider.dataset.mobileEnabled, true);
    var tabletEnabled = dataBool(slider.dataset.tabletEnabled, true);
    var desktopEnabled = dataBool(slider.dataset.desktopEnabled, true);

    if (width >= 1024) return desktopEnabled;
    if (width >= 768) return tabletEnabled;
    return mobileEnabled;
  }

  function getEnabledSlider(card) {
    if (!card || !card.closest) return null;
    var slider = card.closest("gridy-slider");
    if (!slider || !isSliderEnabled(slider)) return null;
    return slider;
  }

  function hideIndicators(card) {
    if (!card) return;
    var wrap = card.querySelector(".card-image-indicators");
    if (wrap && wrap.style.display !== "none") {
      wrap.style.display = "none";
    }
  }

  function isComparisonHoverLocked(card) {
    return !!(card && card.classList && card.classList.contains("comparison-lock-hover-image"));
  }

  function normalizeImageUrl(url) {
    return (url || "").replace(/&amp;/g, "&").trim();
  }

  function getImageIdentityKey(url) {
    var normalized = normalizeImageUrl(url);
    if (!normalized) return "";

    var pathname = normalized;
    try {
      pathname = new URL(normalized, window.location.href).pathname || normalized;
    } catch (error) {}

    return pathname.replace(/_(\d+x\d+|\d+x|x\d+)(?=\.[a-z0-9]+$)/i, "");
  }

  function hasDistinctHoverImages(card) {
    if (!card || !card.querySelector) return false;
    if (!card.classList || !card.classList.contains("on-hover")) return false;

    var hoverWrap = card.querySelector(".card-hover-images");
    if (!hoverWrap || !hoverWrap.children || hoverWrap.children.length < 2) return false;

    var primaryContainer = hoverWrap.children[0];
    var secondaryContainer = hoverWrap.children[1];
    if (!primaryContainer || !secondaryContainer) return false;

    var primaryImg = primaryContainer.querySelector("img");
    var secondaryImg = secondaryContainer.querySelector("img");
    if (!primaryImg || !secondaryImg) return false;

    var primaryUrl = normalizeImageUrl(primaryImg.currentSrc || primaryImg.getAttribute("src") || "");
    var secondaryUrl = normalizeImageUrl(secondaryImg.currentSrc || secondaryImg.getAttribute("src") || "");
    if (!primaryUrl || !secondaryUrl) return false;

    var primaryKey = getImageIdentityKey(primaryUrl);
    var secondaryKey = getImageIdentityKey(secondaryUrl);
    if (primaryKey && secondaryKey) return primaryKey !== secondaryKey;

    return primaryUrl !== secondaryUrl;
  }

  function setIndicatorState(indicators, showSecondary) {
    if (!indicators || indicators.length < 2) return;
    if (showSecondary) {
      indicators[0].classList.remove("is-active");
      indicators[1].classList.add("is-active");
    } else {
      indicators[0].classList.add("is-active");
      indicators[1].classList.remove("is-active");
    }
  }

  function clamp(val, min, max) {
    return val < min ? min : (val > max ? max : val);
  }

  function parseDurationMs(value) {
    var str = (value || "").toString().split(",")[0].trim();
    if (!str) return 0;
    var num = parseFloat(str);
    if (!isFinite(num)) return 0;
    if (str.slice(-2) === "ms") return num;
    if (str.slice(-1) === "s") return num * 1000;
    return num * 1000;
  }

  function getZoomDuration(card) {
    var el = card.querySelector(".media > *");
    if (!el || !window.getComputedStyle) return 400;
    var style = getComputedStyle(el);
    var dur = parseDurationMs(style.transitionDuration);
    var delay = parseDurationMs(style.transitionDelay);
    var total = dur + delay;
    return total > 0 ? total : 400;
  }

  function bindZoom(card) {
    if (!zoomEnabled || !card || zoomBound.has(card)) return;
    zoomBound.add(card);

    var media = card.querySelector(".card-media");
    if (!media) return;
    var zoomAllowed = !!(card.classList && card.classList.contains("card--hover-zoom-enabled"));

    var target = card.querySelector(".card-hover-images .media") ||
      card.querySelector(".card-media .media") ||
      media;
    var zoomOutDelay = getZoomDuration(card);
    var leaveTimer = null;
    var zoomResetTimer = null;
    var zoomRafId = null;
    var zoomCurrentX = null;
    var zoomCurrentY = null;
    var zoomTargetX = null;
    var zoomTargetY = null;

    function setHoverOn() {
      if (isComparisonHoverLocked(card)) {
        return;
      }
      if (card.classList.contains("single-self-swatch-lock")) {
        card.classList.remove("is-hovered");
        card.classList.remove("is-secondary");
        return;
      }
      if (!hasDistinctHoverImages(card)) {
        card.classList.remove("is-hovered");
        return;
      }
      if (leaveTimer) {
        clearTimeout(leaveTimer);
        leaveTimer = null;
      }
      if (card.classList.contains("on-hover")) {
        card.classList.add("is-hovered");
      }
    }

    function setHoverOff() {
      if (isComparisonHoverLocked(card)) {
        return;
      }
      if (card.classList.contains("single-self-swatch-lock")) {
        card.classList.remove("is-hovered");
        card.classList.remove("is-secondary");
        return;
      }
      if (!hasDistinctHoverImages(card)) {
        card.classList.remove("is-hovered");
        return;
      }
      if (!card.classList.contains("on-hover")) return;
      if (leaveTimer) clearTimeout(leaveTimer);
      leaveTimer = setTimeout(function () {
        card.classList.remove("is-hovered");
        leaveTimer = null;
      }, zoomOutDelay);
    }

    function clearZoomReset() {
      if (!zoomResetTimer) return;
      clearTimeout(zoomResetTimer);
      zoomResetTimer = null;
    }

    function scheduleZoomReset() {
      clearZoomReset();
      zoomResetTimer = setTimeout(function () {
        card.style.removeProperty("--card-zoom-x");
        card.style.removeProperty("--card-zoom-y");
        zoomResetTimer = null;
      }, zoomOutDelay);
    }

    function setZoomOn() {
      clearZoomReset();
      card.classList.add("is-zoomed");
    }

    function setZoomOff() {
      if (zoomRafId) {
        cancelAnimationFrame(zoomRafId);
        zoomRafId = null;
      }
      card.classList.remove("is-zoomed");
      scheduleZoomReset();
    }

    function setZoomPoint(x, y) {
      card.style.setProperty("--card-zoom-x", clamp(x, 0, 100) + "%");
      card.style.setProperty("--card-zoom-y", clamp(y, 0, 100) + "%");
    }

    function stepZoomFollow() {
      if (zoomTargetX === null || zoomTargetY === null) {
        zoomRafId = null;
        return;
      }

      if (zoomCurrentX === null || zoomCurrentY === null) {
        zoomCurrentX = zoomTargetX;
        zoomCurrentY = zoomTargetY;
      } else {
        zoomCurrentX += (zoomTargetX - zoomCurrentX) * ZOOM_FOLLOW_LERP;
        zoomCurrentY += (zoomTargetY - zoomCurrentY) * ZOOM_FOLLOW_LERP;
      }

      var dx = Math.abs(zoomTargetX - zoomCurrentX);
      var dy = Math.abs(zoomTargetY - zoomCurrentY);
      if (dx < 0.05 && dy < 0.05) {
        zoomCurrentX = zoomTargetX;
        zoomCurrentY = zoomTargetY;
      }

      setZoomPoint(zoomCurrentX, zoomCurrentY);

      if (zoomCurrentX === zoomTargetX && zoomCurrentY === zoomTargetY) {
        zoomRafId = null;
        return;
      }

      zoomRafId = requestAnimationFrame(stepZoomFollow);
    }

    function update(e, immediate) {
      var rect = target.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      var x = ((e.clientX - rect.left) / rect.width) * 100;
      var y = ((e.clientY - rect.top) / rect.height) * 100;
      zoomTargetX = clamp(x, 0, 100);
      zoomTargetY = clamp(y, 0, 100);

      if (immediate || zoomCurrentX === null || zoomCurrentY === null) {
        zoomCurrentX = zoomTargetX;
        zoomCurrentY = zoomTargetY;
        setZoomPoint(zoomCurrentX, zoomCurrentY);
        return;
      }

      if (!zoomRafId) {
        zoomRafId = requestAnimationFrame(stepZoomFollow);
      }
    }

    if (zoomAllowed) {
      media.addEventListener("mouseenter", function (e) {
        setZoomOn();
        update(e, true);
      });
      media.addEventListener("mousemove", function (e) {
        update(e, false);
      });
      media.addEventListener("mouseleave", setZoomOff);
    }
    card.addEventListener("mouseenter", setHoverOn);
    card.addEventListener("mouseleave", setHoverOff);
  }

  function bindSwipe(el) {
    if (!el || bound.has(el)) return;

    var card = el.closest(".card.card--product.on-hover");
    if (!card) {
      bound.add(el);
      return;
    }

    if (!allowSwipeEverywhere && (isHomepage() || getEnabledSlider(card))) {
      hideIndicators(card);
      bound.add(el);
      return;
    }

    if (card.classList.contains("single-self-swatch-lock")) {
      hideIndicators(card);
      bound.add(el);
      return;
    }

    bound.add(el);
    if (!hasTouch) return;

    var indicators = card.querySelectorAll(".card-image-indicator");
    var startX = 0;
    var startY = 0;
    var lastDx = 0;
    var isSwiping = false;
    var suppressClick = false;

    el.addEventListener("touchstart", function (e) {
      if (!e.touches || e.touches.length !== 1) {
        isSwiping = false;
        suppressClick = false;
        lastDx = 0;
        return;
      }

      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      lastDx = 0;
      isSwiping = false;
      suppressClick = false;
    }, { passive: true });

    el.addEventListener("touchmove", function (e) {
      if (!e.touches || e.touches.length !== 1) return;
      var dx = e.touches[0].clientX - startX;
      var dy = e.touches[0].clientY - startY;
      var absX = Math.abs(dx);
      var absY = Math.abs(dy);

      if (absX < SWIPE_THRESHOLD || absX < absY) return;

      isSwiping = true;
      suppressClick = true;
      lastDx = dx;
      e.preventDefault();
    }, { passive: false });

    el.addEventListener("touchend", function (e) {
      if (!isSwiping) return;
      if (isComparisonHoverLocked(card)) {
        return;
      }
      var dx = lastDx;
      var absX = Math.abs(dx);

      if (absX < SWIPE_THRESHOLD) return;

      if (dx < 0) {
        card.classList.add("is-secondary");
        setIndicatorState(indicators, true);
      } else {
        card.classList.remove("is-secondary");
        setIndicatorState(indicators, false);
      }
    });

    el.addEventListener("touchcancel", function () {
      isSwiping = false;
      suppressClick = false;
      lastDx = 0;
    }, { passive: true });

    el.addEventListener("click", function (e) {
      if (!suppressClick) return;
      e.preventDefault();
      e.stopPropagation();
      suppressClick = false;
    }, true);
  }

  function scanCards() {
    dedupeRecommendationCardsInScope(document);

    var cards = document.querySelectorAll(".card.card--product.on-hover");
    var onHome = isHomepage();

    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      updateSingleSwatchHoverLock(card);
      if (!allowSwipeEverywhere && (onHome || getEnabledSlider(card))) {
        hideIndicators(card);
      }
    }

    if (hasTouch) {
      var nodes = document.querySelectorAll(".card.card--product.on-hover .card-media");
      for (var j = 0; j < nodes.length; j++) {
        bindSwipe(nodes[j]);
      }
    }

    var recommendationCards = document.querySelectorAll(".card.card--product");
    for (var r = 0; r < recommendationCards.length; r++) {
      var recommendationCard = recommendationCards[r];
      syncRecommendationSwatchSelection(recommendationCard);
      bindRecommendationSwatchInteractions(recommendationCard);
      if (hasTouch) {
        bindRecommendationSwatchPrefetch(recommendationCard);
      }
    }
    sortRecommendationCardsInScope(document);

    if (zoomEnabled) {
      var zoomCards = document.querySelectorAll(".card.card--product");
      for (var k = 0; k < zoomCards.length; k++) {
        bindZoom(zoomCards[k]);
      }
    }

    initSveaListings(document);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scanCards);
  } else {
    scanCards();
  }

  ["ajaxinate:loaded", "shopify:section:load", "collection:updated", "product-grid:updated", "woolman:collection:navigated"]
    .forEach(function (evt) {
      document.addEventListener(evt, scanCards);
    });

  var moAdd = new MutationObserver(function (muts) {
    var doit = false;
    for (var i = 0; i < muts.length; i++) {
      if (muts[i].addedNodes && muts[i].addedNodes.length) {
        doit = true;
        break;
      }
    }
    if (doit) {
      requestAnimationFrame(scanCards);
    }
  });
  moAdd.observe(document.documentElement, { childList: true, subtree: true });
})();
